module.exports = __webpack_public_path__ + "img/link.d69abb41.svg";